import { FgaUserState, RoleDtoRole, type FgaUser } from '@/generated/model';

import type { UserAccessState } from '../types/UserAccessState';

export function filterDeactivatedUsers<T extends { state: UserAccessState }>(
  users: T[],
  showDeactivated: boolean
): T[] {
  if (showDeactivated) {
    return users;
  }

  return users.filter((user) => user.state !== FgaUserState.DEACTIVATED);
}

type UserListFeedbackParams = {
  hasMore: boolean;
  isError: boolean;
  isFetchingNextPage: boolean;
  loadedUserCount: number;
  visibleUserCount: number;
};

export function getUserListFeedback({
  hasMore,
  isError,
  isFetchingNextPage,
  loadedUserCount,
  visibleUserCount,
}: UserListFeedbackParams) {
  return {
    showBackgroundError: isError && loadedUserCount > 0,
    showManualLoadMore: !isError && !isFetchingNextPage && hasMore && visibleUserCount === 0,
  };
}

type ShouldShowWelcomeCardParams = {
  isLoading: boolean;
  hasMore: boolean;
  searchText: string;
  users: FgaUser[];
  currentUserId?: number;
  canAddUser: boolean;
};

export function shouldShowWelcomeCard({
  isLoading,
  hasMore,
  searchText,
  users,
  currentUserId,
  canAddUser,
}: ShouldShowWelcomeCardParams): boolean {
  const [onlyUser] = users;

  return (
    !isLoading &&
    !hasMore &&
    searchText === '' &&
    users.length === 1 &&
    onlyUser.id === currentUserId &&
    onlyUser.role.role === RoleDtoRole.clientAdministrator &&
    canAddUser
  );
}
